import { useContext, useEffect, useState } from "react";

import AppContext from "../services/appContext";
import { GBR_EMAIL, NETWORK_RAIL_EMAIL } from "../constants/email.constants";

const useUser = (email) => {
  // email prop is optional, by default the current logged-in user email will be checked.
  const { user } = useContext(AppContext);

  const [isGBR, setGBR] = useState(false);
  const [isNR, setNR] = useState(false);

  useEffect(() => {
    const emailToCheck = email || user?.email || "";

    setGBR(emailToCheck.includes(GBR_EMAIL));
    setNR(emailToCheck.includes(NETWORK_RAIL_EMAIL));
  }, [email, user]);

  return { isGBR, isNR, user };
};

export default useUser;
